module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/.pnpm/echo-loader@0.0.1/node_modules/echo-loader/echo-loader.js!../../../../node_modules/.pnpm/babel-loader@9.2.1_@babel+core@7.29.0_webpack@5.105.4/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[1]!./about.jsx"));
	}, "about");
}